
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import _ from 'lodash';
    import * as Publicaciones from '@/__env/lib/MercadoLibre/Publicaciones';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Publicacion } from '@/__env/lib/MercadoLibre/Publicaciones';
    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Seleccionados() { return this.Controlador.Seleccionados; }

        public Estado: Publicaciones.Estados = null;

        public Abierto: boolean = false;
        public Cargando: boolean = false;
        public get Ok(): boolean
        {
            return ( this.Estado && this.Estado.esActiva && this.Seleccionados.filter( x => x.Estado.esPausada ).hasRows() ) ||
                   ( this.Estado && this.Estado.esPausada && this.Seleccionados.filter( x => x.Estado.esActiva ).hasRows() );
        }

        public async Ejecutar()
        {
            if ( await Utiles.Mensajes.SiNo( 'Editar estado', `¿Sobreescribir el estado de  ${this.Seleccionados.length} publicaciones?` ) )
            {
                this.Cargando = true;
                if ( this.Transporte && this.Transporte.Existe )
                {
                    for ( let e of this.Seleccionados )
                    {
                        if ( !e.Envio.Tipo.esRetiraCliente )
                        {
                            e.Envio.EmpresaLogistica = this.Transporte;
                            await e.Envio.save();
                        }
                    }
                    this.Controlador.Buscador.Buscar();
                    this.Controlador.RecargarEstadistica();
                }
                this.Cargando = false;
                this.Cerrar();
            }


        }

        public async Cerrar()
        {
            this.$emit( 'cerrar' );
            this.Abierto = false;

        }
    }
